(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whynot-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.getAttribute('data-wn-ready')) return;
      root.setAttribute('data-wn-ready', '1');

      var slides = root.querySelectorAll('.wn-announce__slide');
      for (var k = 0; k < slides.length; k++) {
        slides[k].setAttribute('aria-hidden', k === 0 ? 'false' : 'true');
      }
      if (slides.length < 2) return;

      var speed = parseInt(root.getAttribute('data-speed'), 10) || 4000;
      var current = 0;
      var timer = null;

      function show(n) {
        var next = (n + slides.length) % slides.length;
        if (next === current) return;
        var prev = slides[current];
        for (var m = 0; m < slides.length; m++) {
          slides[m].classList.remove('is-leaving');
          slides[m].setAttribute('aria-hidden', 'true');
        }
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        slides[next].classList.remove('is-leaving');
        slides[next].classList.add('is-active');
        slides[next].setAttribute('aria-hidden', 'false');
        current = next;
      }

      function start() {
        stop();
        timer = setInterval(function () { show(current + 1); }, speed);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      root.addEventListener('wn-announce:goto', function (e) {
        show(e.detail);
        start();
      });

      start();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-wn-announce]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-wn-announce]') || (e.target.matches('[data-wn-announce]') ? e.target : null));
    });

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target;
      var root = slide.closest('[data-wn-announce]');
      if (!root) return;
      var list = root.querySelectorAll('.wn-announce__slide');
      for (var i = 0; i < list.length; i++) {
        if (list[i] === slide) {
          root.dispatchEvent(new CustomEvent('wn-announce:goto', { detail: i }));
          break;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
